declare const defaultIsGrid, angular: ng.IAngularStatic
export class productListController {
    products: any;
    ajaxLoading = true;
    limit = 4
    showList = defaultIsGrid == 'true' ? true : false;
    constructor(private $rootScope, private $document, private $mdMedia) {
        "ngInject"

    }
    $onInit() {
        this.$rootScope.$on('startLoading', () => {
            this.ajaxLoading = true;
            var someElement = angular.element(document.getElementById('product-list'));
            this.$document.scrollToElement(someElement, 150, 500);
        })
        if (this.products) {
            this.ajaxLoading = false;
        }
        this.$rootScope.$on('endLoading', () => {
            this.ajaxLoading = false;
        })
        this.$rootScope.$on('changeProductView', () => {
            this.showList = !this.showList;
        })

        if (this.$mdMedia('max-width: 600px')) {
            this.showList = true;
        }
    }


}



// WEBPACK FOOTER //
// ./src/components/product-list/product-list.controller.ts